module.exports = __webpack_public_path__ + "static/media/servicing1.c6205db3.jpg";